import apiService from './apiService';

export const organizationsService = {
  // ==================== Organizations CRUD ====================

  async getOrganizations(params?: { page?: number; limit?: number }): Promise<any> {
    return apiService.get('/organizations', { params });
  },

  async getOrganization(id: string): Promise<any> {
    return apiService.get(`/organizations/${id}`);
  },

  async getOrganizationByDomain(domain: string): Promise<any> {
    return apiService.get(`/organizations/domain/${encodeURIComponent(domain)}`);
  },

  async createOrganization(data: { name: string; description?: string; website?: string; logo?: string }): Promise<any> {
    return apiService.post('/organizations', data);
  },

  async updateOrganization(
    id: string,
    data: {
      name?: string;
      description?: string;
      website?: string;
      logo?: string;
      settings?: any;
    }
  ): Promise<any> {
    return apiService.put(`/organizations/${id}`, data);
  },

  async deleteOrganization(id: string): Promise<void> {
    return apiService.delete(`/organizations/${id}`);
  },

  // ==================== Organization Members ====================

  async getMembers(organizationId: string, params?: { role?: string; page?: number; limit?: number }): Promise<any> {
    return apiService.get(`/organizations/${organizationId}/members`, { params });
  },

  async getMember(organizationId: string, userId: string): Promise<any> {
    return apiService.get(`/organizations/${organizationId}/members/${userId}`);
  },

  async addMember(organizationId: string, data: { userId: string; role: 'member' | 'admin' | 'owner' }): Promise<any> {
    return apiService.post(`/organizations/${organizationId}/members`, data);
  },

  async updateMember(organizationId: string, userId: string, data: { role: 'member' | 'admin' | 'owner' }): Promise<any> {
    return apiService.put(`/organizations/${organizationId}/members/${userId}`, data);
  },

  async removeMember(organizationId: string, userId: string): Promise<void> {
    return apiService.delete(`/organizations/${organizationId}/members/${userId}`);
  },

  // ==================== Organization Invitations ====================

  async createInvitation(
    organizationId: string,
    data: {
      email: string;
      role: 'member' | 'admin';
      message?: string;
      expiresInDays?: number;
    }
  ): Promise<any> {
    return apiService.post(`/organizations/${organizationId}/invitations`, data);
  },

  async getInvitations(organizationId: string, params?: { status?: string; page?: number; limit?: number }): Promise<any> {
    return apiService.get(`/organizations/${organizationId}/invitations`, { params });
  },

  async revokeInvitation(organizationId: string, invitationId: string): Promise<void> {
    return apiService.delete(`/organizations/${organizationId}/invitations/${invitationId}`);
  },

  async checkInvitation(code: string): Promise<any> {
    return apiService.get(`/organizations/invitations/${code}/check`);
  },

  async redeemInvitation(code: string): Promise<any> {
    return apiService.post(`/organizations/invitations/${code}/redeem`);
  },

  // ==================== Organization Teams ====================

  async getOrganizationTeams(organizationId: string, params?: { page?: number; limit?: number }): Promise<any> {
    return apiService.get(`/organizations/${organizationId}/teams`, { params });
  },
};
